"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentConnectionInfo = void 0;
const cookies_1 = require("./cookies");
/** returns info on the current Portal/Cloud connection */
const getCurrentConnectionInfo = (window) => {
    const connectionIndexMatch = window.location.pathname.match(/^\/u\/([0-9]+|demo)(?:\/(.*))?$/);
    if (!connectionIndexMatch) {
        return null;
    }
    const connectionIndex = Number.parseInt(connectionIndexMatch[1].replace('demo', cookies_1.DEMO_CONNECTION_INDEX.toString()));
    const connectionIndexExtra = connectionIndexMatch[2];
    const productMatch = connectionIndexExtra === null || connectionIndexExtra === void 0 ? void 0 : connectionIndexExtra.match(/^([^\/]+)(?:\/(.*))?$/);
    const product = (productMatch === null || productMatch === void 0 ? void 0 : productMatch[1]) || undefined;
    const productPath = (productMatch === null || productMatch === void 0 ? void 0 : productMatch[2]) || undefined;
    return {
        connectionIndex,
        product,
        productPath,
    };
};
exports.getCurrentConnectionInfo = getCurrentConnectionInfo;
